import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	padding: 0 20px;
	margin: 0 auto;
	position: relative;
	z-index: 10;
	.mo-top-box,
	.mo-content,
	.mo-banner-wrap {
		display: none;
	}

	.flex-wrapper {
		display: flex;
		.left {
			max-width: 880px;
			width: 100%;
			border-right: 1px solid #eee;
			padding-right: 80px;
			.writer {
				position: relative;
				.writer-user-box {
					max-width: 760px;
					width: 100%;
					border-radius: 20px;
					color: #fff;
					margin-top: 100px;
					padding: 36px 50px;
					position: relative;
					border-radius: 20px;
					background: linear-gradient(438deg, #776c61 23.62%, #a19487 95.32%);
					.bg {
						background-image: url(/images/bg07.png);
						background-repeat: no-repeat;
						height: 192px;
						background-size: cover;
						background-repeat: no-repeat;
						position: absolute;
						top: 0;
						right: 0;
						width: 100%;
					}
					.user-flex {
						display: flex;
						justify-content: space-between;
						position: relative;
						z-index: 1;
						.user-left {
							display: flex;
							gap: 44px;
							.user {
								width: 120px;
								height: 120px;
								border-radius: 50%;
								/* border: 1px solid rgba(0, 0, 0, 0.4); */
								background-size: cover;
								background-position: center;
								background-repeat: no-repeat;
							}
							.user-name {
								display: flex;
								gap: 12px;
								h3 {
									font-size: 26px;
									font-weight: 700;
									line-height: 160%;
								}
								p {
									color: #fff;
									font-size: 14px;
									font-weight: 400;
									line-height: 160%;
									position: relative;
									top: 12px;
									opacity: 0.6;
								}
							}
						}
						.user-right {
							display: flex;
							align-items: baseline;
							gap: 6px;
							position: relative;
							top: 10px;
							color: #fff;
							transition: all 0.3s;
							cursor: pointer;
							&:hover {
								opacity: 0.8;
							}
							p {
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
							}
							img {
								position: relative;
								top: 2px;
							}
						}
					}
				}
				.under-article-box {
					display: flex;
					justify-content: end;
				}
				.under-article {
					border-radius: 20px;
					border: 1px solid #eee;
					background: #fff;
					padding: 28px 34px;
					max-width: 566px;
					width: 100%;
					margin-top: -100px;
					position: relative;
					z-index: 10;
					display: flex;
					.article-left {
						width: 18%;
						border-right: 1px solid #eee;
						h2 {
							font-size: 20px;
							font-weight: 500;
							line-height: 160%;
						}
						p {
							font-size: 14px;
							font-weight: 400;
							line-height: 160%;
							opacity: 0.4;
						}
					}
					.mo-article-left {
						display: none;
					}
					.article-right {
						padding-left: 24px;
						display: flex;
						align-items: center;
						.cont {
							max-width: 385px;
							font-size: 13px;
							font-weight: 300;
							line-height: 150%;
							opacity: 0.8;
							word-break: keep-all;
						}
					}
				}
			}
			.total {
				margin-top: 60px;
				p {
					font-size: 18px;
					font-weight: 400;
					line-height: 150%;
					span {
						color: #ffbc00;
					}
				}
			}
			.article-wrap {
				margin-top: 54px;
				margin-left: 2px;

				.title {
					font-size: 42px;
					font-weight: 700;
					line-height: 150%;
					margin-bottom: 53px;
				}
				.flex-wrap {
					display: flex;
					justify-content: space-between;
					.left-box {
						width: 100%;
						.line {
							border-top: 1px solid #eee;
							margin: 50px 0 54px 0;
							&:last-child {
								border-top: none;
							}
						}
					}
				}
				.card-box {
					display: block;
					/* border-bottom: 1px solid #eee;
					padding-bottom: 49px;
					margin-bottom: 54px; */
					&:last-child {
						border-bottom: none;
					}
				}
				.article-card {
					display: flex;
					gap: 37px;
					align-items: center;
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						opacity: 0.8;
					}

					.article-img {
						width: 250px;
						height: 0;
						padding-bottom: 68.8%;
						border-radius: 16px;
						background-repeat: no-repeat !important;
						background-size: cover !important;
						background-position: center !important;
					}
					.text-box {
						max-width: 584px;
						width: 100%;
						.tag-box {
							display: flex;
							gap: 12px;
							.cate {
								color: #e99210;
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
								margin-top: 5px;
							}
						}
						h3 {
							margin-top: 7px;
							font-size: 26px;
							font-weight: 700;
							line-height: 140%;
						}
						.content {
							margin-top: 9px;
							color: #888;
							font-size: 14px;
							font-weight: 400;
							line-height: 160%;
							overflow: hidden;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							padding-right: 30px;
						}
						.flex {
							display: flex;
							margin-top: 16px;
							align-items: center;
							.user-box {
								display: flex;

								.user {
									width: 16px;
									height: 16px;
									border-radius: 50%;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;
									margin-right: 6px;
									border: 0.5px solid #eee;
									&:nth-child(2) {
										position: relative;
										left: -10px;
									}
									&:nth-child(3) {
										position: relative;
										left: -20px;
									}
								}
							}
							p {
								font-size: 13px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
							}
							.name {
								font-size: 13px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
								position: relative;
								display: flex;
								align-items: center;
								gap: 4px;
								img {
									width: 16px;
								}
								&::after {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -13px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.date {
								color: #000;
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
								position: relative;
								&::before {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -13px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
						}
					}
				}
				.right-box {
					max-width: 256px;
					width: 100%;
					.shapes-box {
						width: 100%;
						height: 320px;
						border-radius: 18px;
						padding: 30px;
						position: relative;
						top: -82px;
						left: -2px;
						margin-bottom: 30px;

						.shapes-card {
							width: 100%;
							height: 100%;
							background-size: cover;
							background-repeat: no-repeat;
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							cursor: pointer;
							transition: all 0.3s;

							&:hover {
								opacity: 0.8;
							}
						}
						.article-title {
							color: #000;
							font-size: 32px;
							font-weight: 700;
							line-height: normal;
							position: relative;
							z-index: 1;
							opacity: 0.5;
						}
						.total {
							font-size: 14px;
							opacity: 0.6;
							font-weight: 400;
							line-height: normal;
							position: absolute;
							right: 30px;
							bottom: 30px;
						}
					}
				}
				.btn-wrap {
					max-width: 894px;
					width: 100%;
					display: flex;
					justify-content: center;
					position: relative;
					top: -17px;
					.more {
						border-radius: 16px;
						border: 1px solid #eee;
						background: #fff;
						display: flex;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						gap: 8px;
						width: 151px;
						height: 54px;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							opacity: 0.8;
						}
						p {
							font-size: 14px;
							font-weight: 600;
							line-height: 150%;
						}
					}
				}
			}
		}
		.right {
			margin-top: 100px;
			padding-left: 40px;
			max-width: 340px;
			width: 100%;
			.series {
				margin-top: 0px;
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-bottom: 26px;
					margin-left: -3px;
				}
				.series-list {
					.list {
						margin-top: 20px;
						transition: all 0.3s;
						a {
							display: inline-flex;
							align-items: center;
							gap: 24px;
						}
						&:hover {
							opacity: 0.8;
						}
						.seriesimg {
							width: 68px;
							height: 68px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							h4 {
								font-size: 16px;
								font-weight: 700;
							}
							p {
								margin-top: 6px;
								color: #666;
								font-size: 14px;
								font-weight: 400;
							}
						}
					}
				}
			}
			.tag {
				margin-top: 100px;
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-left: -3px;
				}
				ul {
					margin-top: 26px;
					display: flex;
					flex-wrap: wrap;
					gap: 12px 10px;
					li {
						padding: 7px 18px;
						border-radius: 50px;
						border: 1px solid #eee;
						background: #fff;
						font-size: 16px;
						font-weight: 300;
						display: inline-block;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							background: #f7f7f7;
						}
					}
				}
			}
		}
	}
	.result {
		width: 100%;
		display: flex;
		justify-content: center;
		height: 624px;
		position: relative;

		.result-box {
			width: 279px;
			height: 168px;
			background-image: url(/images/result.png);
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			p {
				padding-top: 44px;
				text-align: center;
				font-size: 18px;
				font-weight: 400;
				line-height: 150%;
			}
		}
	}
	@media screen and (max-width: 1230px) {
		.flex-wrapper {
			.left {
				.writer {
					.writer-user-box {
						max-width: 760px;
						width: 100%;
						border-radius: 20px;
						color: #fff;
						margin-top: 100px;
						padding: 36px 50px;
						position: relative;
						.bg {
							height: 192px;
							background-size: cover;
							background-repeat: no-repeat;
							position: absolute;
							top: 0;
							right: 0;
						}
						.user-flex {
							display: flex;
							justify-content: space-between;
							position: relative;
							z-index: 1;
							.user-left {
								display: flex;
								gap: 44px;
								.user {
									width: 120px;
									height: 120px;
									border-radius: 50%;
								}
								.user-name {
									display: flex;
									gap: 12px;
									h3 {
										font-size: 26px;
										font-weight: 700;
										line-height: 160%;
									}
									p {
										font-size: 14px;
										font-weight: 400;
										line-height: 160%;
										position: relative;
										top: 15px;
									}
								}
							}
							.user-right {
								display: flex;
								align-items: baseline;
								gap: 4px;
								position: relative;
								top: 10px;

								p {
									font-size: 13px;
									font-weight: 400;
									line-height: 140%;
								}
								img {
									top: -3px;
								}
							}
						}
					}
					.under-article {
						padding: 28px 34px;
						max-width: 486px;
						width: 100%;
						margin-right: -20px;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.flex-wrapper {
			display: flex;
			.left {
				padding-right: 30px;
				.writer {
					.writer-user-box {
						padding: 26px 40px;
						.bg {
							border-radius: 20px;
						}
						.user-flex {
							display: flex;
							justify-content: space-between;
							position: relative;
							z-index: 1;
							.user-left {
								gap: 18px;
								.user {
									width: 80px;
									height: 80px;
								}
								.user-name {
									display: flex;
									gap: 12px;
									h3 {
										font-size: 20px;
									}
									p {
										font-size: 13px;
										top: 8px;
									}
								}
							}
							.user-right {
								p {
									position: relative;
									top: -5px;
								}
							}
						}
					}
					.under-article {
						padding: 18px 28px;
						width: 100%;
						margin-top: -20px;
						.article-left {
							width: 20%;
						}
					}
				}
				.total {
					margin-top: 122px;
				}
				.article-wrap {
					margin-top: 38px;
					margin-left: 2px;
					.article-card {
						gap: 20px;
						.article-img {
							width: 180px;
							padding-bottom: 70%;
						}
						.text-box {
							h3 {
								margin-top: 7px;
								font-size: 18px;
							}
							.flex {
								p {
									font-size: 12px;
								}
								.name {
									font-size: 12px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
			.right {
				padding-left: 30px;
				max-width: 280px;
			}
		}
	}

	@media screen and (max-width: 768px) {
		margin-top: 28px;
		.flex-wrapper {
			flex-wrap: wrap;
			.left {
				max-width: 100%;
				border-right: none;
				padding-right: 0;
				.writer {
					position: relative;
					padding-right: 10px;
					.writer-user-box {
						max-width: 100%;
						border-radius: 18px;
						margin-top: 0px;
						padding: 24px 30px;
						height: 132px;
						.bg {
							background-image: url(/images/bg07.png);
							width: 100%;
							height: 132px;
						}
						.user-flex {
							.user-left {
								display: flex;
								gap: 28px;
								.user {
									width: 68px;
									height: 68px;
								}
								.user-name {
									flex-direction: column;
									gap: 4px;
									margin-top: 10px;
									h3 {
										font-size: 18px;
									}
									p {
										font-size: 12px;
										top: 0;
									}
								}
							}
							.user-right {
								display: none;
							}
						}
					}
					.under-article {
						border-radius: 18px;
						padding: 22px;
						max-width: 100%;
						/* width: calc(100% - 18px); */
						width: 100%;
						flex-wrap: wrap;
						margin-top: -20px;
						margin-right: -15px;
						.article-left {
							display: none;
						}
						.mo-article-left {
							width: 100%;
							display: flex;
							justify-content: space-between;
							padding-bottom: 16px;
							border-bottom: 1px solid #eee;
							.flex {
								display: flex;
								align-items: center;
								gap: 4px;
								h2 {
									font-size: 18px;
								}
								p {
									font-size: 12px;
									font-weight: 300;
									line-height: 160%;
									opacity: 0.4;
								}
							}
							.mo-right {
								display: flex;
								align-items: center;
								gap: 6px;
								img {
									position: relative;
									top: -1px;
								}
								p {
									font-size: 12px;
									font-weight: 400;
									line-height: 160%;
								}
							}
						}
						.article-right {
							padding-left: 0;
							margin-top: 16px;
							.cont {
								max-width: 100%;
								font-size: 12px;
							}
						}
					}
				}
				.total {
					margin-top: 40px;
					p {
						font-size: 15px;
					}
				}
				.article-wrap {
					margin-top: 42px;
					margin-left: 2px;
					.title {
						display: none;
					}
					.flex-wrap {
						flex-wrap: wrap;
						.left-box {
							width: 100%;
							.line {
								margin: 30px 0;
							}
						}
					}
					.card-box {
						display: block;
						/* border-bottom: 1px solid #eee;
						padding-bottom: 30px;
						margin-bottom: 30px; */
						&:last-child {
							padding-bottom: 0;
							margin-bottom: 0;
						}
					}
					.article-card {
						flex-wrap: wrap;
						gap: 16px;
						.cardimgbox {
							width: 100%;
						}
						.article-img {
							width: 100%;
							height: 0;
							padding-bottom: 55.4%;
							border-radius: 16px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							max-width: 584px;
							width: 100%;
							margin-left: 10px;
							.tag-box {
								gap: 12px;
								.cate {
									font-size: 12px;
									font-weight: 400;
								}
							}
							h3 {
								margin-top: 6px;
								font-size: 18px;
								overflow: hidden;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
							}
							.content {
								margin-top: 8px;
								font-size: 12px;
								padding-right: 0px;
							}
							.flex {
								margin-top: 9px;
								p {
									font-size: 12px;
								}
								.name {
									font-size: 12px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
					.right-box {
						display: none;
					}
				}
			}
			.mo-banner-wrap {
				width: 100%;
				display: block;
				.mo-banner {
					padding: 22px 24px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					border-radius: 8px;
					p {
						font-size: 18px;
						font-weight: 600;
						line-height: 140%;
						max-width: 185px;
						word-break: keep-all;
						margin-bottom: 12px;
					}
					span {
						display: flex;
						align-items: center;
						gap: 6px;
						font-size: 12px;
						font-weight: 400;
						line-height: normal;
						img {
							width: 4px;
							height: 8px;
						}
					}
				}
				.line {
					border-bottom: 8px solid #f7f7f7;
					margin: 60px -20px 0 -20px;
				}
			}
			.right {
				margin-top: 0px;
				padding-left: 0;
				max-width: 100%;
				.top-box {
					display: none;
				}
				.content {
					display: none;
				}

				.series {
					margin-top: 60px;
					h3 {
						margin-bottom: 20px;
						margin-left: 8px;
					}
					.series-list {
						.list {
							gap: 20px;
							margin-top: 20px;
							.seriesimg {
								width: 58px;
								height: 58px;
							}
						}
					}
				}
				.tag {
					margin-top: 60px;
					h3 {
						margin-left: 8px;
					}
					ul {
						margin-top: 20px;
						li {
							padding: 7px 18px;
						}
					}
				}
			}
		}
		.result {
			height: 400px;
			.result-box {
				width: 220px;
				height: 132px;
				p {
					padding-top: 35px;
					font-size: 14px;
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	margin-top: 100px;
	.banner {
		width: 100%;
		background: #d9d9d9;
		padding: 60px 60px 54px 60px;
		border-radius: 18px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		p {
			font-size: 30px;
			font-weight: 600;
			margin-bottom: 23px;
		}
		span {
			font-size: 18px;
			font-weight: 400;
			display: flex;
			align-items: center;
			gap: 10px;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
